export const QUARTER_HOUR_STEP_SECONDS = 15 * 60;

const QUARTER_HOUR_MINUTES = new Set([0, 15, 30, 45]);
const TIME_VALUE_PATTERN = /^([01]\d|2[0-3]):([0-5]\d)(?::([0-5]\d)(?:\.\d+)?)?$/;

export const QUARTER_HOUR_TIME_OPTIONS = Array.from({ length: 24 * 4 }, (_, index) => {
    const totalMinutes = index * 15;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
});

export function isQuarterHourTimeValue(value: string): boolean {
    const normalizedValue = value.trim();

    if (normalizedValue === '') {
        return true;
    }

    const match = TIME_VALUE_PATTERN.exec(normalizedValue);

    if (!match) {
        return false;
    }

    const minutes = Number(match[2]);
    const seconds = match[3] ? Number(match[3]) : 0;

    return seconds === 0 && QUARTER_HOUR_MINUTES.has(minutes);
}

export function isQuarterHourDateTimeLocalValue(value: string): boolean {
    const normalizedValue = value.trim();

    if (normalizedValue === '') {
        return true;
    }

    const [, timeValue] = normalizedValue.split('T');

    if (!timeValue) {
        return false;
    }

    return isQuarterHourTimeValue(timeValue);
}

export function splitDateTimeLocalValue(value: string): { date: string; time: string } {
    const normalizedValue = value.trim().slice(0, 16);

    if (normalizedValue === '' || !normalizedValue.includes('T')) {
        return { date: '', time: '' };
    }

    const [date, time] = normalizedValue.split('T');

    return {
        date: date ?? '',
        time: time ?? '',
    };
}

export function composeDateTimeLocalValue(date: string, time: string): string {
    const normalizedDate = date.trim();
    const normalizedTime = time.trim();

    if (normalizedDate === '' || normalizedTime === '') {
        return '';
    }

    return `${normalizedDate}T${normalizedTime.slice(0, 5)}`;
}
